import { device } from "shared/styles/helpers"
import { NavBarHeight, IndentedMarginTopSmall, IndentedMarginTop } from "shared/styles/theme";
import styled, { css } from "styled-components"


const PageHeaderSharedCss = css`
    margin-bottom:35px;
    display:flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 7px;
`;
export const RelativePageHeaderContainer = styled.div`
    ${PageHeaderSharedCss}
`;
export const StickyPageHeaderContainer = styled.div`
    ${PageHeaderSharedCss}
    position: sticky;
    top: calc(${IndentedMarginTopSmall} + ${NavBarHeight});
    @media ${device.laptop} {
        top: calc(${IndentedMarginTop} + ${NavBarHeight});
    }
`